import styled from 'styled-components'

export const ResultItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #3a3a3a;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #2a2a2a;
  }

  &:last-child {
    border-bottom: none;
  }
`

export const ResultHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
`

export const ResultTitle = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  color: #ffffff;
  flex: 1;
  word-break: break-word;
`

export const ResultType = styled.span`
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background-color: #3a3a3a;
  color: #999999;
  white-space: nowrap;
  text-transform: capitalize;
`

export const ResultMeta = styled.div`
  display: flex;
  gap: 0.75rem;
  font-size: 0.75rem;
  color: #999999;
  flex-wrap: wrap;
`

export const ResultDescription = styled.div`
  font-size: 0.75rem;
  color: #999999;
  margin-top: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`
